export default "__VITE_ASSET__CKNP3C1G__"